import React, { useState, useEffect, useContext, useMemo } from "react";
import Server from "../../Shared/Server";
import Spinner from "../../Shared/Spinner";
import BackButton from "../../Shared/BackButton";
import { FaPrint } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import AuthContext from "../../../context/auth/AuthContext";
import "./InvoiceStyle.css";

const formatNumber = (value) => {
  const num = parseFloat(value);
  if (isNaN(num)) return '0.00';
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

function Invoice() {
  const [invoice, setInvoice] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const currency = user?.branch?.currency || '$'

  useEffect(() => {
    if (location.state){
        const {payload} = location.state
        fetchData(payload)
    } else {
        toast.error("No invoice data provided.");
        navigate(-1);
    }
  }, []);

  const fetchData = async (payload) => {
    setIsLoading(true);
    try {
      const response = await Server.post("/billed/invoice", payload);
      setInvoice(response?.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      if (error.response?.status === 401) {
        localStorage.removeItem("user");
        navigate("/login");
      } else {
        toast.error(error.response?.data?.detail || "Error fetching invoice.");
        navigate(-1);
      }
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const grandTotal = useMemo(() => {
    if (!invoice?.bill_data) return 0;
    return invoice.bill_data.reduce((sum, item) => sum + parseFloat(item.total), 0);
  }, [invoice]);

  if (isLoading || !invoice) {
    return <Spinner />;
  }

  const { inovice_number: invoiceNumber, bill_date, bill_data, location_data, branch_data } = invoice;

  return (
    <div className="invoice-container">
      <div className="invoice-actions no-print">
        <BackButton to={-1} label="Back" />
        <button className="btn btn-primary" onClick={handlePrint}>
          <FaPrint /> &nbsp;Print
        </button>
      </div>
      <div className="invoice-card">
        <div className="invoice-header">
          <div className="invoice-header-info mt-3">
            <h3>{branch_data.name}</h3>
            <h3>Invoice</h3>
            <p>{branch_data.email} | {branch_data.contacts.join(" / ")}</p>
          </div>
        </div>

        <div className="invoice-details">
          <div className="invoice-number-date">
            <p><strong>Invoice #:</strong> {invoiceNumber}</p>
            <p><strong>Bill Date:</strong> {bill_date}</p>
          </div>
          <div className="customer-info">
            <p><strong>Magac:</strong> {location_data.full_name}</p>
            <p><strong>Lambar:</strong> {location_data.contact_number}</p>
          </div>
        </div>

        <div className="invoice-table-wrapper">
          <table className="invoice-table">
            <thead>
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Summad</th>
                <th>Akh.Hore</th>
                <th>Akh.Dambe</th>
                <th>Farqi</th>
                <th>R.Hore</th>
                <th>Biil</th>
                <th>Wadar</th>
              </tr>
            </thead>
            <tbody>
              {bill_data.length > 0 ? (
                <>
                  {bill_data.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.location_id}</td>
                      <td>{item.remark}</td>
                      <td>{item.previous_reading}</td>
                      <td>{item.current_reading}</td>
                      <td>{item.difference}</td>
                      <td>{currency}{formatNumber(item.previous_balance)}</td>
                      <td>{currency}{formatNumber(item.debit)}</td>
                      <td>{currency}{formatNumber(item.total)}</td>
                    </tr>
                  ))}
                  <tr className="invoice-total">
                    <td colSpan="8">Wadar Guud</td>
                    <td>{currency}{formatNumber(grandTotal)}</td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center' }}>No bill data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {branch_data.accounts.length > 0 && (
          <div className="payment-info">
            <h5>PAYMENT ACCOUNTS:</h5>
            {branch_data.accounts.map((account, index) => (
                <p key={index}>{account.name}: {account.number}</p>
            ))}
            <p className="payment-note">
              {branch_data.note}.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Invoice;